module.exports = __webpack_public_path__ + "static/media/balance-scale-left.9220f3c2.svg";